module.exports = __webpack_public_path__ + "img/lk-mode-mobile-green.a1b233b6.svg";